import React from 'react';
import styles from './footerFront.module.css';
import { Link } from 'react-router-dom';

function FooterFront() {
  return (
    <div className={styles.outerMain}>
      <p className={styles.text}>© Copyrights owned by UK EZHAVA MATRIMONY</p>
      {/* <p className={styles.subText}>Managed by Nanops</p> */}
    </div>
  );
}

export default FooterFront;
